module.exports = __webpack_public_path__ + "static/media/solar-panel.161697f8.png";